import {Component, OnDestroy, OnInit} from '@angular/core';
import {TourService} from '../services/tour.service';
import {TourApiService} from '../services/tour-api.service';
import {Subscription} from 'rxjs/Rx';
import {EnumAware} from '../decorators/enum-aware.decorator';
import {SurveyApiService} from '../services/survey-api.service';

@Component({
  selector: 'gt-nav-toolbar',
  templateUrl: './nav-toolbar.component.html',
  styleUrls: ['./nav-toolbar.component.css']
})
@EnumAware
export class NavToolbarComponent implements OnInit, OnDestroy {

  tourLoaded = false;
  tourLoadedSubscription: Subscription;
  reviewsOverviewAvailable = false;
  reviewsOverviewSubscription: Subscription;
  constructor(public apiService: TourApiService,
              public surveyApiService: SurveyApiService,
              public tourService: TourService) { }

  ngOnInit() {

    this.tourLoadedSubscription = this.apiService.tourLoaded.subscribe(
      (loaded: boolean) => {
        this.tourLoaded = loaded;
      }
    );

    if (this.surveyApiService.reviewsOverview === null) {
      this.reviewsOverviewSubscription = this.surveyApiService.reviewsOverviewLoaded.subscribe(
        (loaded: boolean) => {
          this.reviewsOverviewAvailable = loaded;
        }
      );
    } else {
      this.reviewsOverviewAvailable = true;
    }
  }

  ngOnDestroy() {
    if (this.tourLoadedSubscription != null) {
      this.tourLoadedSubscription.unsubscribe();
    }
    if (this.reviewsOverviewSubscription != null) {
      this.reviewsOverviewSubscription.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/nav-toolbar.component.ts